// Import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Blazy from 'blazy';
import { InView } from 'react-intersection-observer';

// Components
import PageScrollAnimation from '../../../../components/PageScrollAnimation';
import Card from '../Card';
import FilterBar from '../FilterBar';

class CardListing extends React.Component {
  constructor(props) {
    super(props);
    this.lazyImages = null;
  }

  componentDidMount() {
    this.lazyImages = new Blazy({
      selector: '.js-react-lazy',
      successClass: 'is-lazyloaded',
      errorClass: 'has-load-error',
      offset: 200,
    });

    PageScrollAnimation({
      selector: '.js-react-animate',
      eleAnimated: 'is-animated',
      mediaQuery: 900,
    });
  }

  componentDidUpdate() {
    this.lazyImages.revalidate();
  }

  componentWillUnmount() {
    this.lazyImages.destroy();
  }

  render() {
    const {
      entries,
      onFilterChange,
      categories,
      onLoadMore,
      initialLimit,
    } = this.props;

    const inViewThresholdI = initialLimit * 0.75;

    return (
      <div className="c-card-listing">
        <FilterBar categories={categories} onChange={onFilterChange} />

        <div className="c-card-listing__wrapper">
          <div className="c-card-listing__content">
            {entries.map((entry, i) => (
              <div className="c-card-listing__section" key={entry.id}>
                <div className="c-card-listing__inner">
                  {i % initialLimit === inViewThresholdI
                    && (
                      <InView
                        as="div"
                        onChange={(inView) => inView && onLoadMore()}
                        triggerOnce
                      />
                    )}

                  <Card
                    key={entry.id}
                    title={entry.title}
                    url={entry.url}
                    description={entry.description}
                    images={entry.imageListing}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

CardListing.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string,
    imageListing: PropTypes.arrayOf(
      PropTypes.string,
    ),
  })).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  onLoadMore: PropTypes.func.isRequired,
  initialLimit: PropTypes.number.isRequired,
};

export default CardListing;
